<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="login-card login-dark">
        <div>
          <div>
            <a class="logo" routerLink="/">
              <!-- <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="looginpage" />
              <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="looginpage" /> -->
              <div class="d-flex gap-2 justify-content-center">
                <img class="img-fluid for-light" src="./../../../assets/svg/logo.svg" alt="looginpage" />
                <h4 class="mb-0 fw-bold text-black mt-4">Digital Salon</h4>
              </div>

            </a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="loginForm">
              <h4>Sign in to account</h4>
              <p>Enter your email & password to login</p>
              <div class="form-group">
                <label class="col-form-label">Email Address</label>
                <input class="form-control" type="email" required="" placeholder="" formControlName="email" />
                <div *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.required" class="text font-11 text-danger mt-1 position-absolute">Email is required</div>
                <div *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.email" class="text font-11 text-danger mt-1 position-absolute">Invalid Email</div>
              </div>
              <div class="form-group pt-2">
                <label class="col-form-label">Password</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password" required="" placeholder="" />
                <!-- <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div> -->
                <div *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required" class="text font-11 text-danger mt-1 position-absolute">Password is required</div>
              </div>
              <div class="form-group pt-2 mb-0">
                <div class="checkbox p-0">
                  <input class="form-check-input checkbox hand" type="checkbox" role="switch" id="checkbox1"
                    formControlName="rememberMe" (change)="onChange(loginForm.get('rememberMe')?.value)" />
                  <label for="checkbox1">Remember</label>
                </div>
                <!-- <a href="javascript:void(0)" class="link">Forgot password?</a> -->
                <div class="text-end mt-3 mb-3">
                  <button class="btn btn-primary d-block w-100" [disabled]="!loginForm.valid" (click)="login()" type="button"><span>Sign in</span></button>
                </div>
              </div>
              <!-- <h6 class="text-muted mt-4 or">Or Sign in with</h6>
              <div class="social mt-4">
                <div class="btn-showcase">
                  <a class="btn btn-light" target="_blank"> <app-feather-icons [icon]="'log-in'" class="txt-google"></app-feather-icons>Google + </a>
                  <a class="btn btn-light" target="_blank"> <app-feather-icons [icon]="'facebook'" class="txt-fb"></app-feather-icons>Facebook </a>
                  <a class="btn btn-light" target="_blank"> <app-feather-icons [icon]="'twitter'" class="txt-twitter"></app-feather-icons>twitter </a>
                </div>
              </div>
              <p class="mt-4 mb-0">
                Don't have account?
                <a href="javascript:void(0)" class="ms-2">Create Account</a>
              </p> -->
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
